<template>
  <div>
    <configurar-associacao-fila-tipo-solicitacao-dialog
      :is-configurar-associacao-fila-tipo-solicitacao-dialog-open.sync="isAddNewFilaDialogOpen"
      :tipo-solicitacao-id="tipoSolicitacaoId"
      @refetch-data="getTipoSolicitacaoFilas"
    />

    <v-card
      flat
      class="pa-3 mt-2"
    >
      <v-card class="d-flex justify-space-between">
        <v-card-title>Filas</v-card-title>

        <v-btn
          v-if="!acessoPost"
          color="primary"
          class=" ma-3"
          disabled
        >
          <span>Adicionar</span>
        </v-btn>

        <v-btn
          v-else
          color="primary"
          class=" ma-3"
          @click="isAddNewFilaDialogOpen = !isAddNewFilaDialogOpen"
        >
          <span>Adicionar</span>
        </v-btn>
      </v-card>

      <div style="min-height: 4px">
        <v-progress-linear
          v-if="loading"
          indeterminate
          @refetch-data="getTipoSolicitacaoFilas"
        />
      </div>

      <table-associacao-tipo-solicitacao-fila
        :items="tipoSolicitacaoFilas"
        :acesso-disable="acessoDisable"
        :tipo-solicitacao-id="tipoSolicitacaoId"
        @refetch-data="getTipoSolicitacaoFilas"
      />
    </v-card>
  </div>
</template>

<script>
import { ref, onMounted } from '@vue/composition-api'
import { mapState } from 'pinia'
import router from '@/router'
import ConfigurarAssociacaoFilaTipoSolicitacaoDialog from '@/views/fila/tab-tipo-solicitacao/ConfigurarAssociacaoFilaTipoSolicitacaoDialog.vue'
import TableAssociacaoTipoSolicitacaoFila from './TableAssociacaoTipoSolicitacaoFila.vue'
import TipoSolicitacaoService from '@/services/modules/TipoSolicitacaoService'
import useAuthStore from '@/store/auth'

export default {
  components: {
    ConfigurarAssociacaoFilaTipoSolicitacaoDialog,
    TableAssociacaoTipoSolicitacaoFila,
  },

  props: {
    ativo: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      idPost: 2015,
      acessoPost: true,
      idDisable: 2016,
      acessoDisable: true,
    }
  },

  computed: {
    ...mapState(useAuthStore, ['funcionalidades']),
  },

  mounted() {
    // this.permissoes()
  },

  methods: {
    permissoes() {
      if (!this.funcionalidades.includes(this.idPost)) {
        this.acessoPost = false
      }
      if (!this.funcionalidades.includes(this.idDisable)) {
        this.acessoDisable = false
      }
    },
  },

  setup() {
    const tipoSolicitacaoId = Number(router.currentRoute.params.id)
    const isAddNewFilaDialogOpen = ref(false)

    const tipoSolicitacaoFilas = ref([])
    const loading = ref(false)

    async function getTipoSolicitacaoFilas() {
      try {
        loading.value = true
        tipoSolicitacaoFilas.value = await TipoSolicitacaoService.getTiposDeSolicitacoesAssociadosAUmaFila(tipoSolicitacaoId)
      } finally {
        loading.value = false
      }
    }
    onMounted(getTipoSolicitacaoFilas)

    return {
      tipoSolicitacaoId,
      isAddNewFilaDialogOpen,
      tipoSolicitacaoFilas,
      loading,
      getTipoSolicitacaoFilas,
    }
  },
}
</script>
